// extracted by mini-css-extract-plugin
export default {"scoreContainer":"StopWatchScoreComponent_scoreContainer__o-Sdw","header":"StopWatchScoreComponent_header__O8i+G","options":"StopWatchScoreComponent_options__8KQ02"};